<main class="thanks2" id="thanks2-app" v-cloak :class="'thanks2--' + viewClass">
    <div class="thanks2__inner">
        <header class="thanks2__hero">
            <p class="thanks2__label">Reservation request</p>
        </header>

        <section class="thanks2__patterns" aria-label="ご予約内容">

            <article v-if="state === 'loading'" class="thanks2-card">
                <p class="thanks2-card__status">予約情報を取得しています…</p>
            </article>

            <article v-else-if="state === 'error'" class="thanks2-card thanks2-card--warning">
                <p class="thanks2-card__badge">エラー</p>
                <div class="thanks2-card__icon" aria-hidden="true">!</div>
                <p class="thanks2-card__status">{{ errorMessage }}</p>
                <div class="thanks2-contact">
                    <p>お問い合わせ</p>
                    <span>ご予約に関するお問い合わせは下記までご連絡ください。</span>
                    <a href="tel:0120-427-869">0120-427-869</a>
                    <small>受付時間 10:00〜20:00</small>
                </div>
            </article>

            <article v-else-if="state === 'confirmed'" class="thanks2-card thanks2-card--success">
                <p class="thanks2-card__badge">予約確定</p>
                <div class="thanks2-card__icon" aria-hidden="true">✓</div>
                <p class="thanks2-card__status">ご予約を確定しました</p>
                <div class="thanks2-date thanks2-date--success">
                    <span class="thanks2-date__icon" aria-hidden="true"></span>
                    <strong>{{ confirmedDate }}</strong>
                    <em>{{ confirmedTime }}</em>
                    <span>にてご予約を確定させて頂きました。</span>
                </div>
                <dl class="thanks2-detail">
                    <div>
                        <dt>店舗</dt>
                        <dd>{{ merchantName }}</dd>
                    </div>
                    <div>
                        <dt>お名前</dt>
                        <dd>{{ customerName }}</dd>
                    </div>
                    <div>
                        <dt>電話番号</dt>
                        <dd>{{ customerPhone }}</dd>
                    </div>
                </dl>
                <div class="thanks2-note thanks2-note--success">
                    <p>ご登録のメールアドレスに予約確認メールをお送りしました。</p>
                    <p>ご来店を心よりお待ちしております。</p>
                </div>
            </article>

            <article v-else class="thanks2-card thanks2-card--warning">
                <p class="thanks2-card__badge">日程再確認</p>
                <div class="thanks2-card__icon" aria-hidden="true">!</div>
                <p class="thanks2-card__status">お申し込み頂いた日程で<br>ご予約をお受けできませんでした。</p>
                <p class="thanks2-card__text">下記の日程であればご予約を承れますが、如何でしょうか？</p>

                <form class="thanks2-form" @submit.prevent="submit">
                    <p class="thanks2-card__caption">ご都合の日時を選択してください。</p>
                    <div class="thanks2-suggest">
                        <div class="thanks2-suggest__group" v-for="g in groupedSuggestions" :key="g.date">
                            <p class="thanks2-suggest__date">{{ g.date }}</p>
                            <ul class="thanks2-timechips thanks2-timechips--selectable" role="radiogroup" aria-label="予約可能な時間">
                                <li v-for="t in g.times" :key="t.ts">
                                    <button type="button"
                                            role="radio"
                                            :aria-checked="selected === t.ts"
                                            :class="{ 'is-selected': selected === t.ts }"
                                            @click="selected = t.ts">
                                        {{ t.time }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button class="thanks2-button thanks2-button--warning" type="submit" :disabled="submitting || selected === null">
                        {{ submitting ? "送信中…" : "この日時で予約を確定する" }}
                    </button>
                </form>

                <p class="thanks2-or">または</p>

                <form class="thanks2-form thanks2-form--select" @submit.prevent="submitCustom">
                    <p class="thanks2-card__caption">ご希望の日時を入力してください。</p>
                    <div class="thanks2-custom">
                        <label>
                            <span>日付を選択</span>
                            <input type="text" ref="customDateInput" :value="customDate" readonly placeholder="日付を選択">
                        </label>
                        <label>
                            <span>時間を選択</span>
                            <select v-model="customTime">
                                <option value="">時間を選択</option>
                                <option v-for="t in customTimeOptions" :key="t" :value="t">{{ t }}</option>
                            </select>
                        </label>
                    </div>
                    <button class="thanks2-button thanks2-button--alternate" type="submit" :disabled="submitting">
                        {{ submitting ? "送信中…" : "この日時で予約を希望する" }}
                    </button>
                </form>

                <p v-if="submitError" class="thanks2-card__caption" style="color:#c9501f; margin-top:14px;">{{ submitError }}</p>

                <div class="thanks2-contact">
                    <p>ご予約に不安がある場合</p>
                    <span>ご予約の流れなどご不明な点がございましたら、お気軽にお問い合わせください。</span>
                    <a href="tel:0120-427-869">0120-427-869</a>
                    <small>受付時間 10:00〜20:00</small>
                </div>
            </article>

        </section>

        <section class="thanks2-guide" aria-label="ご来店にあたってのお願い">
            <h3>ご来店にあたってのお願い</h3>
            <ul>
                <li>
                    <span class="thanks2-guide__icon thanks2-guide__icon--clock" aria-hidden="true"></span>
                    <strong>時間に余裕を持ってお越しください</strong>
                    <p>ご予約時間の5分前を目安にご来店をお願いいたします。</p>
                </li>
                <li>
                    <span class="thanks2-guide__icon thanks2-guide__icon--paper" aria-hidden="true"></span>
                    <strong>キャンセルポリシー</strong>
                    <p>ご変更・キャンセルは前日までにご連絡をお願いいたします。</p>
                </li>
                <li>
                    <span class="thanks2-guide__icon thanks2-guide__icon--card" aria-hidden="true"></span>
                    <strong>ご予約の変更・確認</strong>
                    <p>お電話またはLINEから内容の確認や変更が可能です。</p>
                </li>
            </ul>
        </section>
    </div>
</main>
